import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.scss";
import Main from "./containers/Main";
import Blog from "./containers/Blog";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Main} />
        <Route path="/blog" component={Blog} />
      </Switch>
    </Router>
  );
}

export default App;